import React, { useEffect, useRef, useState } from "react";
import { CSSTransition } from "react-transition-group";
import { useForm } from "react-hook-form";
import { isValidPhoneNumber } from "../../../phone-input"
import ProductCard from "../ProductCard";
import * as api from "../../api";
import ReserveConfirmPhone from "../ReserveConfirmPhone";
import ReserveError from "../ReserveError/ReserveError";
import ReserveSuccess from "../ReserveSuccess/ReserveSuccess";
import Spinner from "../../Spinner"
import eSputnik from "../../../eSputnik";
import { GUID } from "../../../../utils";

export default function Reserve({ product, storeId }) {
  const { phrases } = window;
  const bookModalInfoRef = useRef(null);
  const [needCheck, setNeedCheck] = useState(false);
  const [reservedObj, setReservedObj] = useState(null);
  const [errorObj, setErrorObj] = useState(null);
  const [errorEnterPhoneStep, setErrorEnterPhoneStep] = useState(null);
  const [errorConfirmPhoneStep, setErrorConfirmPhoneStep] = useState(null);
  const orderData = useRef({});

  const { setValue, getValues, register, handleSubmit, formState } = useForm({
    defaultValues: {
      name: "",
      phone: "",
    },
  });

  useEffect(() => {
    if (bookModalInfoRef.current) {
      bookModalInfoRef.current.innerHTML =
        phrases?.product?.["book_modal_info"] ||
        "Reservation is valid for <strong>24 hours</strong> and includes a <strong>maximum of 2 items</strong>";
    }
    window.maskedInput();
  });

  const onSubmit = async (data = {}) => {
    // eslint-disable-next-line camelcase
    const isConfirmPhoneStep = Boolean(data.sms_code);
    switch (true) {
      case isConfirmPhoneStep:
        orderData.current.sms_code = data.sms_code;
        break;
      case Boolean(data.name && data.phone):
        orderData.current = {
          name: data.name,
          phone: data.phone.replace(/\D/g, ""),
          sku: product.sku,
          external_shop_id: storeId,
        };
        break;
      default:
        break;
    }
    setErrorConfirmPhoneStep(null);
    setErrorEnterPhoneStep(null);

    try {
      const res = await api.reservation(isConfirmPhoneStep, orderData.current);
      if (res.needCheck) {
        orderData.current.sms_token = res.token;
        setNeedCheck(res.needCheck);
      } else {
        if (errorObj) {
          setErrorObj(null);
        }
        setReservedObj(res);
        setNeedCheck(null);
        eSputnik.CustomerData({
          user_phone: orderData.current.phone || '',
          user_email: '',
          user_name: orderData.current.name || ''
        })
        eSputnik.PurchasedItems([
          {
            options: {
              parent_product: {
                sku: window.sku || '',
                price: window.productDetails?.price || '',
              },
            },
            qty: 1
          },
        ], res.reservNumber, orderData.current.phone);
        // reservDateEnd: "20.10.2022"
        // reservNumber: "1551149153"
        // size: "18"
        // storeName: "Kyiv city, Akademika Glushkova Ave., 13B, shopping center Magela"
      }
    } catch (err) {
      if (err.status === 408) {
        setErrorObj(err.responseJSON);
        setNeedCheck(false);
      }
      if (err.status === 403 && isConfirmPhoneStep) {
        setErrorConfirmPhoneStep(err.responseJSON.error.detail);
      }
      if (err.status === 403 && !isConfirmPhoneStep) {
        // setErrorConfirmPhoneStep(err.responseJSON.error.detail)
        setErrorConfirmPhoneStep(err.responseJSON.error.detail);
        setErrorEnterPhoneStep(err.responseJSON.error.detail);
      }
      if (err.status === 422) {
        setErrorEnterPhoneStep(err.responseJSON.error.title);
      }
      if (err.status === 429) {
        setErrorConfirmPhoneStep(err.responseJSON.error.title);
        setErrorEnterPhoneStep(err.responseJSON.error.title);
      }
    }
  };

  useEffect(() => {
    if (window.phone) {
      const phone = `+${window.phone}`
      setValue("phone", phone, { shouldValidate: true });
    }
    // document
    //   .querySelector("#modal-reserve-phone")
      // .dispatchEvent(new CustomEvent("new-tel-input-rendered", { bubbles: true }));
  }, []);

  useEffect(() => {
    const nameInput = document.querySelector("#modal-reserve-name");
    if (nameInput) {
      nameInput.setAttribute("value", orderData.current.name);
    }
  }, [needCheck])

  return (
    <>
      {/* Reserve confirm phone */}
      <CSSTransition
        in={needCheck}
        appear
        unmountOnExit
        classNames="fade"
        timeout={300}
      >
        <ReserveConfirmPhone
          onConfirmPhone={onSubmit}
          errorMessage={errorConfirmPhoneStep}
          backClickHandler={() => setNeedCheck(false)}
        />
      </CSSTransition>

      {/* Reserve success */}
      <CSSTransition
        in={!!reservedObj}
        appear
        unmountOnExit
        classNames="fade"
        timeout={300}
      >
        <ReserveSuccess reservationDetail={reservedObj} />
      </CSSTransition>

      {/* Reserve error */}
      <CSSTransition
        in={!!errorObj}
        appear
        unmountOnExit
        classNames="fade"
        timeout={300}
      >
        <ReserveError title={errorObj?.title} detail={errorObj?.detail} />
      </CSSTransition>

      {/* Reserve */}
      <CSSTransition
        in={!reservedObj && !needCheck && !errorObj}
        appear
        unmountOnExit
        classNames="fade"
        timeout={300}
      >
        <div
          className="modal modal-medium modal-reserve modal-store-selector-reserve"
          data-target="modal-reserve"
          style={{ display: "block" }}
        >
          <div className="modal__zoom">
            <div className="modal-content modal-contect--narrow">
              <div className="flex">
                <div className="modal-l-side">
                  <div className="close-btn js-close" />
                  <div className="modal__content">
                    <div className="modal__title">
                      {phrases?.product?.["book_modal_title"] ||
                        "Make a reservation"}
                    </div>
                    <div className="cart-items">
                      <ProductCard product={product} />
                    </div>

                    <div className="row-notice">
                      <div className="flex">
                        <p ref={bookModalInfoRef}>
                          {/* Reservation is valid for <strong>24 hours</strong> and includes a <strong>maximum of 2 items</strong> */}
                        </p>
                        <span className="label">!</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-r-side">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <span className="title-form">
                      {phrases?.checkout?.profileStep || "Personal data"}
                    </span>
                    <label className="form-label" htmlFor="modal-reserve-name">
                      <input
                        id="modal-reserve-name"
                        type="text"
                        // name="name"
                        className="form-label__input"
                        autoComplete="off"
                        {...register("name", { required: true })}
                      />
                      <span className="form-label__placeholder">
                        {phrases?.checkout?.fields?.name || "Name"}
                      </span>
                      <span
                        className="error-text"
                        style={{ display: formState.errors.name && "block" }}
                      >
                        {phrases?.checkout?.errors?.name?.required ||
                          "Firstname field is required"}
                      </span>
                    </label>
                    <label className="form-label" htmlFor="modal-reserve-phone">
                      <input
                        id="modal-reserve-phone"
                        type="tel"
                        // name="phone"
                        className="form-label__input"
                        autoComplete="off"
                        // {...defaultPhone}
                        // value="+380 50 000 00 08"
                        onChange={() =>
                          errorEnterPhoneStep && setErrorEnterPhoneStep(null)
                        }
                        {...register("phone", {
                          validate: {
                            minLength: isValidPhoneNumber,
                          }
                        })}
                      />
                      <span className="form-label__placeholder">
                        {phrases?.checkout?.fields?.phone || "Phone number"}
                      </span>
                      <span
                        className="error-text"
                        style={{
                          display:
                            (formState.errors.phone || errorEnterPhoneStep) && "block",
                        }}
                      >
                        {errorEnterPhoneStep ||
                          phrases?.checkout?.errors?.phone?.required ||
                          "Phone number field is required"}
                      </span>
                    </label>
                    <button
                      disabled={formState.isSubmitting}
                      className="wb-btn btn-green reserved"
                    >
                        <CSSTransition
                          in={formState.isSubmitting}
                          appear
                          unmountOnExit
                          classNames="fade"
                          timeout={300}
                        >
                          <Spinner />
                        </CSSTransition>
                        <CSSTransition
                          in={!formState.isSubmitting}
                          appear
                          unmountOnExit
                          classNames="fade"
                          timeout={300}
                        >
                          <span>
                            {phrases?.product?.["buy_book_button_title"] ||
                              "Make a reservation"}
                          </span>
                        </CSSTransition>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
    </>
  );
}
